import React from 'react'
import { ITopic } from './index'

import { Hero } from 'marketing-site/src/library/components/Hero'
import { ComponentGroup } from 'marketing-site/src/library/components/ComponentGroup'

const addBiggerPropToField = (field: any) => {
  if (field?.fields) {
    field.fields.asBiggerCard = true
  }
}

const addBiggerPropToComponents = (components: Array<any>) => {
  components.forEach((field) => {
    addBiggerPropToField(field)
  })

  return components
}

export function Topic(props: ITopic) {
  const { eyebrow, title, description } = props
  return (
    <>
      <div className="hero-wrapper">
        <Hero
          eyebrow={eyebrow}
          headline={title}
          subheading={description}
          renderMainContent={() => <div />}
          layout={{
            leftAlign: false,
            compact: false,
          }}
        />
      </div>
      {props.components && (
        <ComponentGroup components={addBiggerPropToComponents(props.components)} />
      )}
      <style jsx>{`
        .hero-wrapper {
          margin-bottom: -50px;
        }
      `}</style>
    </>
  )
}
